import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { COUNTRIES as COUNTRIES_TID } from "@/constants/testIds";
import {
  getSortedCountriesWithCounts,
  formatCompactCount,
} from "@/utils/countryStats";
import { useOpportunities } from "@/hooks/useOpportunities";

export const Countries = () => {
  const { opportunities, countries: countryList } = useOpportunities();
  const countries = getSortedCountriesWithCounts(countryList, opportunities, { includeEmpty: true });
  const totalCountries = countryList.length;

  return (
    <section
      id="countries"
      data-testid={COUNTRIES_TID.root}
      className="bg-white"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="fursa-eyebrow">Top Countries</p>
            <h2 className="fursa-section-title mt-3 font-semibold tracking-tight text-ink-900">
              تغطية جغرافية للمنطقة العربية
            </h2>
            <p className="mt-3 text-base leading-relaxed text-ink-500">
              فرص من <span className="num">{totalCountries}</span> دولة، مصدرها بيانات رسمية وتقارير قطاعية موثوقة.
            </p>
          </div>
          <div className="fursa-rule w-24" aria-hidden />
        </div>

        <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-4">
          {countries.map((c) => {
            const empty = c.count === 0;
            return (
              <Link
                key={c.slug}
                to={`/opportunities?country=${encodeURIComponent(c.name)}`}
                data-testid={COUNTRIES_TID.item(c.slug)}
                aria-label={`عرض ${c.count} فرصة في ${c.name}`}
                className={`group flex items-center justify-between gap-3 rounded-lg border bg-white px-4 py-3.5 transition-all ${
                  empty
                    ? "border-surface-200 opacity-50"
                    : "border-surface-200 hover:-translate-y-0.5 hover:border-fursa-300 hover:bg-fursa-50 hover:shadow-card-hover"
                }`}
              >
                <span className="inline-flex min-w-0 items-center gap-2.5">
                  <MapPin
                    className={`h-4 w-4 shrink-0 transition-colors ${
                      empty ? "text-ink-500" : "text-ink-500 group-hover:text-fursa-700"
                    }`}
                    strokeWidth={1.75}
                  />
                  <span className="truncate text-sm font-medium text-ink-900">
                    {c.name}
                  </span>
                </span>
                <span
                  dir="ltr"
                  data-testid={`${COUNTRIES_TID.item(c.slug)}-count`}
                  className={`shrink-0 font-mono text-xs font-semibold tabular-nums ${
                    empty ? "text-ink-500" : "text-fursa-700"
                  }`}
                >
                  {formatCompactCount(c.count)}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
